import {
  Component,
  ViewChild,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { ModalComponent } from "../../../components/modal/modal.component";
import { TopLevelFieldMapping } from "../../../models/top-level-field-mapping.model";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import * as _ from "underscore";

@Component({
  selector: "lowy-search-columns",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline">Select Columns</div>
        <div class="subheading">Select columns to view in search grid.</div>
        <div class="seperator"></div>

        <div class="full-mat-line">
          <lowy-dropdown
            #dataGroupDropdown
            [label]="null"
            [placeholder]="'Data Group'"
            (add)="selectedDataGroupChange($event)"
            [data]="dataGroups"
            [singleItemSelection]="true"
          ></lowy-dropdown>
        </div>

        <div class="full-mat-line">
          <lowy-dropdown
            [disabled]="!selectedDataGroup"
            [label]="null"
            [placeholder]="'Data Type'"
            (add)="addColumn($event)"
            [data]="dataTypes"
          ></lowy-dropdown>
        </div>
        <div class="seperator"></div>
        <div class="button-row">
          <span (click)="clearAll()">clear all</span>
          <span (click)="cancel()">cancel</span>
          <span (click)="save()">save</span>
        </div>
      </div>

      <div style="padding: 30px">
        <mat-chip-list>
          <mat-chip
            *ngFor="let column of columnsToAdd"
            class="data-tag"
            (click)="removeColumn(column)"
          >
            {{ column.topLevelDatagroupName }}: {{ column.topLevelColumnName }}
            <i class="material-icons">cancel</i>
          </mat-chip>
        </mat-chip-list>
      </div>
    </lowy-modal>
  `,
  styles: [
    `
      .seperator {
        margin-bottom: 15px;
      }
    `,
  ],
})
export class AddRemoveSearchColumnsComponent {
  @ViewChild("modal") modal: ModalComponent;
  @ViewChild("dataGroupDropdown")
  dataGroupDropdown: DropdownComponent;

  private _topLevelGroups: TopLevelFieldMapping[];
  public dataGroups: TopLevelFieldMapping[];
  public selectedDataGroup: TopLevelFieldMapping;
  public dataTypes: TopLevelFieldMapping[];

  public columnsToAdd: TopLevelFieldMapping[];

  @Input("topLevelGroups") set topLevelGroups(groups: TopLevelFieldMapping[]) {
    this._topLevelGroups = groups;
    this.dataGroups = _.chain(groups)
      .uniq((g) => g.topLevelSpreadsheetId)
      .map((g) => {
        g["name"] = `${g.topLevelSpreadsheetId}: ${g.topLevelDatagroupName}`;
        return g;
      })
      .sortBy("topLevelSpreadsheetId")
      .sortBy("sortOrder")
      .value() as any as TopLevelFieldMapping[];
  }

  @Output() setColumns: EventEmitter<any>;

  constructor() {
    this.setColumns = new EventEmitter();
  }

  public open(columns?: TopLevelFieldMapping[]) {
    this.modal.open();
    if (columns) {
      this.columnsToAdd = columns;
    } else {
      this.columnsToAdd = [];
    }
  }

  clearAll() {
    this.columnsToAdd = [];
  }

  save() {
    this.setColumns.emit(this.columnsToAdd);
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }

  public addColumn(selectedColumns: TopLevelFieldMapping[]) {
    this.columnsToAdd = this.columnsToAdd.concat(selectedColumns);
    this.selectedDataGroup = null;
    this.dataTypes = null;
    this.dataGroupDropdown.clearFilter();
  }

  public removeColumn(column: TopLevelFieldMapping) {
    this.columnsToAdd = _.without(this.columnsToAdd, column);
  }

  async selectedDataGroupChange(dataGroup: TopLevelFieldMapping) {
    this.selectedDataGroup = dataGroup;

    this.dataTypes = _.chain(
      JSON.parse(JSON.stringify(this._topLevelGroups)) as TopLevelFieldMapping[]
    )
      .filter(
        (g) => g["topLevelSpreadsheetId"] === dataGroup.topLevelSpreadsheetId
      )
      .map((g) => {
        g["name"] = `${g.topLevelColumnId}: ${g.topLevelColumnName}`;
        return g;
      })
      .sortBy("topLevelColumnId")
      .sortBy("sortOrder")
      .value();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/search-modals/add-remove-columns-modal.component.ts